<template>
  <div>
    
    <div class="container">
      <div class="logo">神州动力数码</div>
      <div class="shop_search">
        <i-input v-model="sreachData" size="large" @keyup.enter.native="sreach()"  class="sreach" placeholder="输入你想查找的商品">
          <Button slot="append" icon="ios-search"   @click="sreach"></Button>
        </i-input>
        <Tag v-for="(item, index) in promotionTags" :key="index" closable  @on-close="closeTags(index)"><span @click="selectTags(index)">{{item}}</span></Tag>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Search',
  data () {
    return {
      sreachData: '',
      promotionTags: ['联想', '路由器', '交换机']
    };
  },
  methods: {
    closeTags (index) {
      this.promotionTags.splice(index, 1);
    },
    selectTags (index) {
      this.sreachData = this.promotionTags[index];
    },
    sreach () {
      this.$router.push({path: '/goodsList', query: { sreachData: this.sreachData }});
    }
  }
};
</script>

<style scoped>
.logo {
    background-image: url('/static/img/search/logo.png');
    background-position: 0 0;
    background-repeat: no-repeat;
    overflow: hidden;
    display: inline-block;
    width: 180px;
    height: 45px;
    font-size: 0;
    margin-right: 5rem;
}
.container {
  padding-top: 15px;
  margin: 0px auto;
  margin-bottom: 15px;
  width: 960px;
}
.sreach {
  margin: 5px 0px;
  width: 460px;
}
.shop_search{
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue